"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = require("../Icon");
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./style.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Alert = _ref => {
  let {
    alertHeading,
    alertText,
    color,
    className,
    showIcon
  } = _ref;
  let customClass = "";
  if (color === "success") {
    customClass = "success-alert";
  } else if (color === "danger") {
    customClass = "error-alert";
  } else {
    customClass = className;
  }
  const displayIcon = iconName => {
    return /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      icon: iconName,
      style: {
        color: "#ffffff",
        width: "2.25rem",
        height: "2.25rem"
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ixn-alert"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Alert, {
    color: color,
    className: (0, _classnames.default)(`ixn-alert__${customClass}`)
  }, /*#__PURE__*/_react.default.createElement(_react.Fragment, null, showIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: "ixn-alert__show-icon"
  }, color === "success" && displayIcon(["far", "check-circle"]), color === "danger" && displayIcon(["far", "times-circle"])), /*#__PURE__*/_react.default.createElement("div", {
    className: "ixn-alert__alert-content"
  }, alertHeading !== "" && /*#__PURE__*/_react.default.createElement("h4", {
    className: "ixn-alert__alert-heading"
  }, alertHeading), /*#__PURE__*/_react.default.createElement("p", null, alertText)))));
};
exports.Alert = Alert;
Alert.defaultProps = {
  alertHeading: "",
  alertText: "",
  color: "success",
  className: "",
  showIcon: true
};
Alert.propTypes = {
  /** Specifies the heading text to display in the alert box. */
  alertHeading: _propTypes.default.string,
  /** Specifies the body text to display in the alert box. */
  alertText: _propTypes.default.string,
  /** Specifies custom class name. */
  className: _propTypes.default.string,
  /** Specifies the type of Alert. */
  color: _propTypes.default.oneOf(["success", "danger", "error-alert", "success-alert"]),
  /** Icon can be hidden using `showIcon=false`. */
  showIcon: _propTypes.default.bool
};